(function () {
    var browseTaxonomies = {
        init: function () {
            browseTaxonomies.initParentDiv();
            browseTaxonomies.loadTaxonomies();
            browseTaxonomies.initTopicalEAlertEventHandler();
        },

        initParentDiv: function () {
            var $parentDiv = $('.browse-taxonomies-nodes');
            var $height = $('.maxHeight');

            if ($parentDiv.length === 0 || $height.length === 0) {
                return;
            }

            $parentDiv.css('max-height', $height.val() + 'px');
        },

        loadTaxonomies: function () {
            var $parentForm = $('.browse-taxonomies');
            var $children;
            var $journalCode;
            var $taxonomyCode;
            var $useAjaxFixedCounts;
            var $maxDepth;

            if ($parentForm.length === 0) {
                return;
            }

            $children = $parentForm.children('.tagGroup');
            if ($children.length > 0) {
                return;
            }

            $journalCode = $parentForm.find('.journalCode');
            if ($journalCode.length === 0 || $journalCode.val() === '') {
                browseTaxonomies.showError('Error: Could not find journal code.');
                return;
            }

            $taxonomyCode = $parentForm.find('.taxonomyCode');
            if ($taxonomyCode.length === 0 || $taxonomyCode.val() === '') {
                browseTaxonomies.showError('Error: Could not find taxonomy code.');
                return;
            }

            $useAjaxFixedCounts = $parentForm.find('.useAjaxFixedCounts');
            if ($useAjaxFixedCounts.length === 0 || $useAjaxFixedCounts.val() === '') {
                browseTaxonomies.showError(
                    'Error: can not find value for widget property: "Use Ajax to load filters (Fixed count)".'
                );
                return;
            }

            $maxDepth = $parentForm.find('.maxDepth');
            if ($maxDepth.length === 0 || $maxDepth.val() === '') {
                browseTaxonomies.showError('Error: can not find value for widget property: "Max Taxonomy Depth".');
                return;
            }

            browseTaxonomies.afterLoadAjaxRequest(
                $journalCode.val(),
                $taxonomyCode.val(),
                $useAjaxFixedCounts.val(),
                $maxDepth.val()
            );
        },

        onCountClick: function (countDiv) {
            var $countElement = $(countDiv);
            var $navLinks = $countElement.siblings('.nav-links');
            var $collapseLink, $expandLink;

            if ($navLinks.length <= 0) {
                return;
            }

            $collapseLink = $navLinks.find('.collapsible');
            $expandLink = $navLinks.find('.expandable');

            if ($collapseLink.length > 0 && !$collapseLink.hasClass('hidden')) {
                $collapseLink.trigger('click');
                return;
            }

            if ($expandLink.length > 0 && !$expandLink.hasClass('hidden')) {
                $expandLink.trigger('click');
            }
        },

        afterLoadAjaxRequest: function (journalCode, taxonomyCode, useAjaxFixedCounts, maxDepth) {
            var $concepts = $('.conceptsIDs');

            var url = '/pb/widgets/browseTaxonomies/';
            var i;
            var $concept;

            if (useAjaxFixedCounts === 'true') {
                url += 'fixedCountsTree';
            } else {
                url += 'dynamicCountsTree';
            }

            url += '/' + maxDepth + '/' + journalCode + '/' + taxonomyCode;

            if ($concepts.length > 0) {
                url += '?';

                for (i = 0; i < $concepts.length; i++) {
                    $concept = $($concepts[i]);
                    url += 'concept=' + $concept.val();

                    if (i !== $concepts.length - 1) {
                        url += '&';
                    }
                }
            }

            url = browseTaxonomies.includeDateParameters(url);

            $.ajax({
                method: 'GET',
                url: url,
                error: function (xhr) {
                    if (xhr.status === 404) {
                        browseTaxonomies.showError('Error: Ajax is requesting to invalid url.');
                    } else {
                        browseTaxonomies.showError('Error while loading taxonomies tree.');
                    }
                },
            }).done(function (data) {
                var errorEmptyMsg = 'No articles exist with the selected filters combination';
                var treeObj;
                var level = 0;
                var $parentForm = $('.browse-taxonomies');
                var $maxDepth = $parentForm.children('.maxDepth');
                var html;
                var queryString;

                if (data === undefined || data === '') {
                    browseTaxonomies.showError(errorEmptyMsg);
                    return;
                }

                treeObj = $.parseJSON(data);

                if (!treeObj || !treeObj.children || $(treeObj.children).length === 0) {
                    browseTaxonomies.showError(errorEmptyMsg);
                    return;
                }

                if ($parentForm.length === 0) {
                    return;
                }

                if ($maxDepth.length === 0) {
                    browseTaxonomies.showError('Maximum depth widget property is not found.');
                    return;
                }

                html = browseTaxonomies.renderTagNode(treeObj, level, $maxDepth.val());

                $parentForm.append(html);

                queryString = window.location.search.substring(1);

                browseTaxonomies.highlightSelectedTags(queryString);
                browseTaxonomies.registerTagsOnClickEvent();
                browseTaxonomies.closeUnselectedLevels(queryString);
                browseTaxonomies.handleCollapseOrExpandLinkState($parentForm, queryString);

                browseTaxonomies.initDependentWidgets();
            });
        },

        renderTagNode: function (nodeObj, level, maxDepth) {
            var html = '';

            if (level <= maxDepth && $(nodeObj.children).length > 0) {
                html += '<div class="tagGroup" level="' + level + '">';

                $(nodeObj.children).each(function (index, data) {
                    html += browseTaxonomies.renderNode(data, level, maxDepth);
                });

                html += '</div>';
            }

            return html;
        },

        /**
         * Renders the passed node object and all its descendants.
         * the level is passed to keep track of the level we are rendering (also level is used in css padding).
         *
         * @param nodeObj
         * @param level
         * @returns {string}
         */
        renderNode: function (nodeObj, level, maxDepth) {
            var tagName = nodeObj.tagName;
            var tagUri = nodeObj.tagUri;
            var tagChildren = nodeObj.children;
            var useAjaxFixedCounts = $('.useAjaxFixedCounts');
            var hasChildren = nodeObj.hasChildren && ($(tagChildren).length > 0 || useAjaxFixedCounts.val() === 'true');
            var hashCode = nodeObj.hashCode;
            var tagLevel = nodeObj.level;
            var showNavLinks;
            var clickableClass;

            var childTags = '';
            childTags += '<div class="tag" tagUri="' + tagUri + '" hashCode="' + hashCode + '">';

            childTags += '<div class="tag-name-count">';

            childTags += '<div class="tagName" tagUri="' + tagUri + '" hashCode="' + hashCode + '">';
            childTags += '<span class="level-icon"></span>';
            childTags += '<a class="tagLink"><span>' + tagName + '</span></a>';
            childTags += '</div>';

            showNavLinks = hasChildren === true && level + 1 <= maxDepth && tagLevel + 1 <= maxDepth;

            clickableClass = showNavLinks ? 'clickable' : '';

            childTags +=
                '<div class="articleCount ' + clickableClass + '" onclick="UX.browseTaxonomies.onCountClick(this)">';
            childTags += nodeObj.articleCount;
            childTags += '</div>';

            if (showNavLinks) {
                childTags += '<div class="nav-links">';
                childTags += '<a class="nav-icon collapsible hidden" onclick="collapseTag.collapseTag(this)"></a>';
                childTags +=
                    '<a class="nav-icon expandable" onclick="UX.browseTaxonomies.expandTag(\'' +
                    tagUri +
                    "', " +
                    hashCode +
                    ', ' +
                    level +
                    ', ' +
                    maxDepth +
                    ', this)"></a>';
                childTags += '</div>';
            }
            childTags += '</div>'; // End of tag-name-count div.

            if (hasChildren === true) {
                level = level + 1;
                childTags += browseTaxonomies.renderTagNode(nodeObj, level, maxDepth);
            }

            childTags += '</div>'; // End of tag div.

            return childTags;
        },

        showError: function (error) {
            var $errorDiv = $('.browse-taxonomies-error');

            if ($errorDiv.length === 0) {
                return;
            }

            $errorDiv.text(error);
            $errorDiv.removeClass('hidden');
        },

        expandTag: function (tagUri, hashCode, parentLevel, maxDepth, expandableLink) {
            var $parentTag = $(expandableLink).closest('.tag');
            var $tagGroup = $parentTag.find('.tagGroup');
            var $parentForm;
            var $useAjaxFixedCounts;
            var collapsibleSibling;

            if ($tagGroup.length > 0) {
                $($tagGroup[0]).removeClass('hidden');
            } else {
                $parentForm = $(expandableLink).closest('.browse-taxonomies');
                $useAjaxFixedCounts = $parentForm.find('.useAjaxFixedCounts');

                if ($useAjaxFixedCounts.length !== 0 && $useAjaxFixedCounts.val() === 'true') {
                    browseTaxonomies.populateDirectChildrenTagsUsingAjax(
                        $parentForm,
                        $parentTag,
                        parentLevel,
                        maxDepth
                    );
                }
            }

            $(expandableLink).addClass('hidden');

            collapsibleSibling = $(expandableLink).siblings('.collapsible')[0];
            $(collapsibleSibling).removeClass('hidden');
        },

        populateDirectChildrenTagsUsingAjax: function (form, parentTag, parentLevel, maxDepth) {
            var $parentForm = $(form);
            var $parentTag = $(parentTag);
            var hashCode = $parentTag.attr('hashCode');
            var tagUri = $parentTag.attr('tagUri');
            var $expandServiceUrl;
            var url;

            if ($parentForm.length === 0) {
                return;
            }

            $expandServiceUrl = $parentForm.find('.expandServiceUrl');
            url = $expandServiceUrl.val() + hashCode;

            if ($expandServiceUrl.val().indexOf('topicalAlerts') >= 0) {
                // In case of Topical Alerts more path variables are passed.

                url = url + '/' + tagUri + '/' + parentLevel;
            }

            url = browseTaxonomies.includeDateParameters(url);

            $.ajax({
                method: 'GET',
                url: url,
                error: function (xhr) {
                    browseTaxonomies.showError('Error while getting children tags for tagUri [' + tagUri + ']');
                },
            }).done(function (data) {
                var errorEmptyMsg = 'Error while getting children tags for tagUri [' + tagUri + ']';
                var nodeObj;
                var html;
                var queryString;

                if (data === undefined || data === '') {
                    browseTaxonomies.showError(errorEmptyMsg);
                    return;
                }

                nodeObj = $.parseJSON(data);

                if (!nodeObj || !nodeObj.children || $(nodeObj.children).length === 0) {
                    browseTaxonomies.showError(errorEmptyMsg);
                    return;
                }

                html = browseTaxonomies.renderTagNode(nodeObj, parentLevel + 1, maxDepth);
                $parentTag.append(html);

                queryString = window.location.search.substring(1);

                browseTaxonomies.highlightSelectedTags(queryString);
                browseTaxonomies.registerTagsOnClickEvent();
                browseTaxonomies.initDependentWidgets();
            });
        },

        collapseTag: function (collapsibleLink) {
            var $collapseLink = $(collapsibleLink);
            var expandableSibling = $collapseLink.siblings('.expandable')[0];
            var $parentTag = $collapseLink.closest('.tag');
            var $tagGroup = $parentTag.children('.tagGroup');

            $collapseLink.addClass('hidden');
            $(expandableSibling).removeClass('hidden');
            if ($tagGroup.length > 0) {
                $tagGroup.addClass('hidden');
            }
        },

        registerTagsOnClickEvent: function () {
            var $parentForm = $('.browse-taxonomies');
            var $links, i, $link, ev;

            if ($parentForm.length === 0) {
                return;
            }

            $links = $parentForm.find('.tagLink');

            for (i = 0; i < $links.length; i++) {
                $link = $($links[i]);
                ev = $._data($link.get(0), 'events');

                if (ev && ev.click) {
                    // Event already exists
                } else {
                    $link.on('click', browseTaxonomies.registerTagOnClickEvent);
                }
            }
        },

        registerTagOnClickEvent: function (event) {
            var element = $(event.target).parent();
            var $link = $(element);
            var $tagName;
            var tagUri;
            var url;
            var $tag;
            var $tagGroup;
            var level;

            if ($link.length <= 0) {
                return;
            }

            $tagName = $($link[0]).closest('.tagName');

            if ($tagName.length <= 0) {
                return;
            }

            tagUri = $tagName.attr('tagUri');
            url = browseTaxonomies.getSearchServiceUrl($tagName);

            if ($tagName.hasClass('selected')) {
                // url = removeValuedParamFromURL(url, 'ConceptID', tagUri);
                // document.location.href = url;
            } else {
                $tag = $tagName.closest('.tag');
                $tagGroup = $tagName.closest('.tagGroup');
                level = $tagGroup.attr('level');

                url = browseTaxonomies.addParamToUrl(url, 'ConceptID', tagUri); // Note: this method should be called before the two methods below.
                url = browseTaxonomies.addParamToUrl(url, tagUri + '_level', level);
                url = browseTaxonomies.deselectChildren($tag, url);
                url = browseTaxonomies.deselectParent($tag, url);

                document.location.href = url;
            }
        },

        getSearchServiceUrl: function (parentElement) {
            var $element = $(parentElement);
            var $parentForm;
            var $searchUrl;

            if ($element.length === 0) {
                return;
            }

            $parentForm = $element.closest('.browse-taxonomies');
            if ($parentForm.length === 0) {
                return;
            }

            $searchUrl = $parentForm.find('.searchUrl');
            if ($searchUrl.length === 0) {
                return;
            }

            return $searchUrl.val();
        },

        deselectChildren: function (tag, pageUrl) {
            var $tag = $(tag);
            var $tags;

            if ($tag.length === 0) {
                return pageUrl;
            }

            $tags = $tag.find('.tagGroup .tag');

            if ($tags.length === 0) {
                return pageUrl;
            }

            $tags.each(function (index, element) {
                var $tag = $(element);

                var tagUri = $tag.attr('tagUri');
                pageUrl = browseTaxonomies.removeValuedParamFromURL(pageUrl, 'ConceptID', tagUri);
            });

            return pageUrl;
        },

        /**
         * This method deselects parent (if it was selected) for the passed tag.
         *
         * @param tag
         * @param pageUrl
         * @returns {*}
         */
        deselectParent: function (tag, pageUrl) {
            var $tag = $(tag);
            var $parentTags;
            var i, $parentTag, $parentTagNameContainer;
            var $parentSelectedTagName;
            var parentTagUri;

            if ($tag.length === 0) {
                return pageUrl;
            }

            // if there is no parent tags then return.
            $parentTags = $tag.parents('.tagGroup .tag');
            if ($parentTags.length === 0) {
                return pageUrl;
            }

            for (i = 0; i < $parentTags.length; i++) {
                $parentTag = $($parentTags[i]);

                $parentTagNameContainer = $parentTag.children('.tag-name-count');
                if ($parentTagNameContainer.length <= 0) {
                    continue;
                }

                $parentSelectedTagName = $parentTagNameContainer.find('.tagName.selected');

                // Checks if the parent is selected.
                if ($parentSelectedTagName.length <= 0) {
                    continue;
                }

                $parentSelectedTagName.removeClass('selected');

                parentTagUri = $parentSelectedTagName.attr('tagUri');
                pageUrl = paramExistsInUrl.removeValuedParamFromURL(pageUrl, 'ConceptID', parentTagUri);
            }

            return pageUrl;
        },

        highlightSelectedTags: function (queryString) {
            var $parentForm = $('.browse-taxonomies');
            var $tags;
            var j;
            var $tag;
            var $tagUri;

            if ($parentForm.length === 0) {
                return;
            }

            $parentForm = $($parentForm[0]);
            $tags = $parentForm.find('.tagName');

            for (j = 0; j < $tags.length; j++) {
                $tag = $($tags[j]);
                $tagUri = $tag.attr('tagUri');

                if (browseTaxonomies.paramExistsInUrl('ConceptID', $tagUri, queryString)) {
                    $tag.addClass('selected');
                }
            }
        },

        closeUnselectedLevels: function (queryString) {
            var $parentForm = $('.browse-taxonomies');
            var $tagGroups;
            var i, j;
            var $tagGroup;
            var level;
            var $tags;
            var collapseTagGroup;
            var $tag;
            var tagUri;

            if ($parentForm.length === 0) {
                return;
            }

            $tagGroups = $parentForm.find('.tagGroup');

            if ($tagGroups.length === 0) {
                return;
            }

            for (i = 0; i < $tagGroups.length; i++) {
                $tagGroup = $($tagGroups[i]);

                if ($tagGroup.length === 0) {
                    continue;
                }

                level = $tagGroup.attr('level');

                if (level === 0) {
                    continue;
                }

                $tags = $tagGroup.find('.tag');
                collapseTagGroup = true;

                for (j = 0; j < $tags.length; j++) {
                    $tag = $($tags[j]);
                    tagUri = $tag.attr('tagUri');

                    if (paramExistsInUrl.paramExistsInUrl('ConceptID', tagUri, queryString)) {
                        collapseTagGroup = false;
                    }
                }

                if (collapseTagGroup) {
                    $tagGroup.addClass('hidden');
                }
            }
        },

        /**
         * This method is used to hide/show collapse and expand links
         * according to their children state.
         *
         * @param parentForm
         * @param queryString
         */
        handleCollapseOrExpandLinkState: function (parentForm, queryString) {
            var $form = $(parentForm);
            var $tagGroups;
            var i, j;
            var $tagGroup;
            var $tags;
            var hasSelectedChild;
            var $tag;
            var tagUri;
            var $ParentTag;
            var $collapsible;
            var $expandable;

            if ($form.length === 0) {
                return;
            }

            $tagGroups = $form.find('.tagGroup');

            for (i = 0; i < $tagGroups.length; i++) {
                $tagGroup = $($tagGroups[i]);

                if ($tagGroup.length === 0) {
                    continue;
                }

                $tags = $tagGroup.find('.tag');
                hasSelectedChild = false;

                for (j = 0; j < $tags.length; j++) {
                    $tag = $($tags[j]);
                    tagUri = $tag.attr('tagUri');

                    if (browseTaxonomies.paramExistsInUrl.paramExistsInUrl('ConceptID', tagUri, queryString)) {
                        hasSelectedChild = true;
                        break;
                    }
                }

                $ParentTag = $tagGroup.closest('.tag');

                if ($ParentTag.length === 0) {
                    continue;
                }

                $collapsible = $($ParentTag[0]).find('.collapsible');
                $expandable = $($ParentTag[0]).find('.expandable');

                if ($collapsible.length === 0 || $expandable.length === 0) {
                    continue;
                }

                $collapsible = $($collapsible[0]);
                $expandable = $($expandable[0]);

                if (hasSelectedChild) {
                    // show the collapse icon and hide the expand icon.
                    $collapsible.removeClass('hidden');
                    $expandable.addClass('hidden');
                } else {
                    // show the expand icon and hide the collapse icon.
                    $collapsible.addClass('hidden');
                    $expandable.removeClass('hidden');
                }
            }
        },

        includeDateParameters: function (url) {
            var beforeYear = browseTaxonomies.getParameterByName('BeforeYear');
            var beforeMonth = browseTaxonomies.getParameterByName('BeforeMonth');
            var afterYear = browseTaxonomies.getParameterByName('AfterYear');
            var afterMonth = browseTaxonomies.getParameterByName('AfterMonth');
            var firstMonth = browseTaxonomies.getParameterByName('firstMonth');
            var lastMonth = browseTaxonomies.getParameterByName('lastMonth');
            var firstYear = browseTaxonomies.getParameterByName('firstYear');
            var lastYear = browseTaxonomies.getParameterByName('lastYear');

            url = browseTaxonomies.addParamToUrl(url, 'BeforeYear', beforeYear);
            url = browseTaxonomies.addParamToUrl(url, 'BeforeMonth', beforeMonth);
            url = browseTaxonomies.addParamToUrl(url, 'AfterYear', afterYear);
            url = browseTaxonomies.addParamToUrl(url, 'AfterMonth', afterMonth);
            url = browseTaxonomies.addParamToUrl(url, 'firstMonth', firstMonth);
            url = browseTaxonomies.addParamToUrl(url, 'lastMonth', lastMonth);
            url = browseTaxonomies.addParamToUrl(url, 'firstYear', firstYear);
            url = browseTaxonomies.addParamToUrl(url, 'lastYear', lastYear);

            return url;
        },

        initDependentWidgets: function () {
            var $topicalContainer = $('.topical-alerts-container');

            if ($topicalContainer.length === 0) {
                return;
            }

            UX.topicalAlerts.init();
        },

        initTopicalEAlertEventHandler: function () {
            var $browseTaxonomiesContainer = $('.browse-taxonomies-container');
            var $eAlertDiv = $('.register-e-alerts');

            if ($eAlertDiv.length === 0) {
                return;
            }

            if ($browseTaxonomiesContainer.length === 0) {
                $eAlertDiv.remove();
                return;
            }

            $.each($eAlertDiv, function (index, value) {
                var $button = $(value);

                $button.on('click', function (evt) {
                    browseTaxonomies.registerEAlertButtonClicked(evt);
                });
            });
        },

        registerEAlertButtonClicked: function (evt) {
            var $container = $('.browse-taxonomies-container');
            var $code = $('.journalCode');
            var $loginButton = $('#loginButton');
            var jCode = $code.val();
            var topicalAlertName = browseTaxonomies.getTopicalAlertName(jCode, $container);
            var encodedAlertName = encodeURIComponent(topicalAlertName);
            var $button = $(evt.target);
            var $targetPageUrl;
            var urlSeparator;
            var $selectedTags = $('.browse-taxonomies-nodes .tagName.selected');
            var isIipAlert = $selectedTags.length === 0;
            var $selectedFilters = $('.omega-filters .filter');
            var url;
            var $alertButtons = $('.register-e-alerts');
            var encodedIIPAlertName;

            if ($code.length === 0 || $code.val() === '') {
                return;
            }

            window.location.hash = window.location.hash + '#register-clicked';

            if ($loginButton.length > 0) {
                $loginButton.trigger('click');
                return;
            }

            if ($button.length > 0 && $button.hasClass('registered')) {
                $container = $button.closest('.e-alert-container');

                if ($container.length === 0) {
                    return;
                }

                $targetPageUrl = $container.find('.e-alert-target-page');
                if ($targetPageUrl.length === 0) {
                    return;
                }

                urlSeparator = '?';
                if ($targetPageUrl.val().indexOf('?') > 0) {
                    urlSeparator = '&';
                }

                if (isIipAlert && $selectedFilters.length > 0) {
                    isIipAlert = false;
                }

                if (isIipAlert) {
                    encodedIIPAlertName = encodeURIComponent('iipAlertName-' + jCode);
                    window.location = $targetPageUrl.val() + urlSeparator + 'iipAlertName=' + encodedIIPAlertName;
                } else {
                    window.location = $targetPageUrl.val() + urlSeparator + 'topicalAlertName=' + encodedAlertName;
                }

                return;
            }

            url = '/pb/widgets/browseTaxonomies/registerTopicalAlert/';
            url += jCode + '/' + encodedAlertName;

            if ($alertButtons.length === 0) {
                return;
            }

            browseTaxonomies.registerEAlert(url, $alertButtons);
        },

        registerEAlert: function (url, alertButtons) {
            var jsonData, login, error, registerError;

            $.each($(alertButtons), function (index, value) {
                var $button = $(value);

                $button.removeClass('registered');
                $button.addClass('loading');
            });

            $.ajax({
                method: 'GET',
                url: url,
                error: function (xhr) {
                    $(alertButtons).removeClass('loading');

                    alert('Failed to register e-Alert');
                    return;
                },
                success: function (data, textStatus, xhr) {
                    jsonData = $.parseJSON(data);
                    login = jsonData.login;
                    error = jsonData.error;
                    registerError = false;
                    if (login) {
                        //ACSPubs.showLoginForm();
                        registerError = true;
                    } else if (error !== undefined && error !== '' && error !== null) {
                        alert(error);
                        registerError = true;
                    }

                    if (registerError) {
                        $(alertButtons).removeClass('loading');
                        $(alertButtons).removeClass('registered');

                        return;
                    }

                    $(alertButtons).removeClass('loading');
                    $(alertButtons).addClass('registered');
                },
            });
        },

        getTopicalAlertName: function (jCode, container) {
            var $selectedTags = $(container).find('.browse-taxonomies-nodes .tagName.selected');
            var levelsByConcepts = new Map();
            var $filtersSections = $('.omega-filters');
            var $filterSection;
            var $selectedFilters;

            // If "Browse Taxonomies" tags tree does not exist, then try to read selected tags from "omegaFiltersWidget" widget.
            if ($selectedTags.length === 0) {
                if ($filtersSections.length > 0) {
                    $filterSection = $($filtersSections[0]);
                    $selectedFilters = $filterSection.find('.filter');

                    $.each($selectedFilters, function (i, value) {
                        var tagUri = $(value).attr('tagUri');
                        var level = $(value).attr('tagLevel');

                        levelsByConcepts.set(tagUri, level);
                    });
                }
            } else {
                $.each($selectedTags, function (i, value) {
                    var $tagNameElement = $(value);
                    var tagUri = $tagNameElement.attr('taguri');
                    var $tagGroup = $tagNameElement.closest('.tagGroup');

                    var level = $tagGroup.attr('level');

                    levelsByConcepts.set(tagUri, level);
                });
            }

            return browseTaxonomies.generateSaveSearchName(jCode, levelsByConcepts);
        },

        addParamToUrl: function (url, paramName, value) {
            var param;
            var separator;

            if (
                typeof url !== 'undefined' &&
                typeof paramName !== 'undefined' &&
                typeof value !== 'undefined' &&
                value !== ''
            ) {
                value = encodeURIComponent(value);
                param = paramName + '=' + value;

                if (url.indexOf(param) > -1) {
                    return url;
                }

                separator = url.indexOf('?') === -1 ? '?' : '&';
                return url + separator + param;
            }

            return url;
        },

        paramExistsInUrl: function (paramName, paramValue, queryString) {
            var paramArray;
            var i;
            var currentParameter;

            if (queryString.length > 0) {
                //Split Query String into separate parameters
                paramArray = queryString.split('&');

                //Loop through params, check if parameter exists.
                for (i = 0; i < paramArray.length; i++) {
                    currentParameter = paramArray[i].split('=');

                    if (
                        (currentParameter[0] === paramName) &
                        (currentParameter[1] === encodeURIComponent(paramValue))
                    ) {
                        return true;
                    }
                }
            }

            return false;
        },

        /**
         * Removes the passed pair of parameterName and value from the passed URL.
         * This method can be used in case of multi-value fields where you want to remove only one value.
         *
         * @param url
         * @param parameter
         * @param value
         * @returns {*}
         */
        removeValuedParamFromURL: function (url, parameter, value) {
            //prefer to use l.search if you have a location/link object
            var urlparts = url.split('?');
            var prefix;
            var pars;
            var i;

            if (urlparts.length >= 2) {
                prefix = encodeURIComponent(parameter) + '=' + encodeURIComponent(value);
                pars = urlparts[1].split(/[&;]/g);

                for (i = pars.length; i-- > 0; ) {
                    if (pars[i] === prefix) {
                        pars.splice(i, 1);
                    }
                }

                url = urlparts[0] + '?' + pars.join('&');
                return url;
            } else {
                return url;
            }
        },

        getParameterByName: function (name) {
            var regex;
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            (regex = new RegExp('[\\?&]' + name + '=([^&#]*)')), (results = regex.exec(location.search));
            return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
    };

    UX.browseTaxonomies = browseTaxonomies;
})();
